// -----------------------------------------------------------------------------
// Scripts for product gallery
// -----------------------------------------------------------------------------

$(function () {
  const productInfo = $('.product-info');

  $.each(productInfo , function(index, value) {
    const productGalleryFor = $(this).find('.gallery-for').attr('id');
    const productGalleryNav = $(this).find('.gallery-nav').attr('id');

    $(`#${productGalleryFor}`).slick({
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: false,
      fade: true,
      asNavFor: `#${productGalleryNav}`
    });

    $(`#${productGalleryNav}`).slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      asNavFor: `#${productGalleryFor}`,
      dots: false,
      arrows: true,
      centerMode: false,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 992,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 1,
          }
        },
        {
          breakpoint: 480,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
          }
        },
      ]
    });
  });
});